<template>
    <div>
        <div class="homepage__header__placeholder" />
        <div class="homepage__header homepage__header--sticky">
            <header class="container container--header header">
                <Logo :confirm-before-quit="false" />
                <nav class="header__nav">
                    <router-link
                        :to="{ name: 'join' }"
                        class="nav__link header-link nav__link--join"
                    >
                        {{ $t('header.enterCode') }}
                    </router-link>
                    <TeacherHeaderDropdown />
                    <ParentHeaderDropdown />
                    <PricingHeaderDropdown v-if="$showDiscoverPremium" />
                    <div class="spacer" />
                    <router-link
                        class="nav__link d-none-mobile d-none-tablet header-link"
                        :to="{ name: 'auth.register' }"
                    >
                        {{ $t('auth.signUp') }}
                    </router-link>
                    <MathButton
                        class="nav__link d-none-mobile d-none-tablet"
                        @click="logIn"
                    >
                        {{ $t('auth.logIn') }}
                    </MathButton>
                    <MobileBurgerMenu style="margin-left: initial">
                        <li>
                            <router-link :to="{ name: 'auth.login' }">
                                {{ $t('auth.logIn') }}
                            </router-link>
                        </li>
                        <li>
                            <a @click="signUp">
                                {{ $t('auth.signUp') }}
                            </a>
                        </li>
                        <li>
                            <a
                                :href="competitionLink"
                                target="_blank"
                                rel="noopener"
                            >
                                Masters League Competition
                            </a>
                        </li>
                        <li>
                            <a :href="blogLink" target="_blank">Blog</a>
                        </li>
                        <li>
                            <a :href="supportLink" target="_blank">Support</a>
                        </li>
                        <li>
                            <a :href="parentsPageLink" target="_blank">
                                Parent's page
                            </a>
                        </li>
                        <li v-if="$showDiscoverPremium">
                            <a :href="pricingForAdminsLink" target="_blank">
                                Pricing for Admins
                            </a>
                        </li>
                        <li v-if="$showDiscoverPremium">
                            <a :href="pricingForTeachersLink" target="_blank">
                                Pricing for Teachers
                            </a>
                        </li>
                    </MobileBurgerMenu>
                </nav>
            </header>
        </div>
    </div>
</template>

<script>
import Logo from '@/core/ui/_legacy/Logo.vue';
import MathButton from '@/core/ui/_legacy/MathComponents/MathButton.vue';
import MobileBurgerMenu from '@/core/widgets/MathHeader/components/MobileBurgerMenu.vue';
import ParentHeaderDropdown from '@/landing/flows/LandingPage/components/ParentHeaderDropdown.vue';
import PricingHeaderDropdown from '@/landing/flows/LandingPage/components/PricingHeaderDropdown.vue';
import TeacherHeaderDropdown from '@/landing/flows/LandingPage/components/TeacherHeaderDropdown.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        PricingHeaderDropdown,
        Logo,
        MobileBurgerMenu,
        MathButton,
        TeacherHeaderDropdown,
        ParentHeaderDropdown,
    },
    computed: {
        ...mapGetters({
            currentLanguage: 'getCurrentLanguage',
        }),
        parentsPageLink() {
            return 'https://parents.99math.com/';
        },
        blogLink() {
            return 'https://www.blog.99math.com/';
        },
        supportLink() {
            return 'https://support.99math.com/support/solutions';
        },
        pricingForAdminsLink() {
            return 'https://pricing.99math.com/';
        },
        pricingForTeachersLink() {
            return 'https://99math.com/premium/';
        },
        competitionLink() {
            return `${window.location.origin}/public-monthly-competition`;
        },
    },
    methods: {
        signUp() {
            this.$router.push({ name: 'auth.register' });
        },
        logIn() {
            this.$router.push({ name: 'auth.login' });
        },
    },
};
</script>

<style lang="scss">
@use 'sass:color';
@use '@/scss/capacitor/mobile';
.homepage__header {
    background-color: #572598;
    box-sizing: border-box;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    height: 88px;
    padding-left: 20px;
    position: relative;
    z-index: 5;

    @include mq($w-max-phone, max) {
        @include mobile.safe-area-top;
        height: calc(64px + var(--safe-area-inset-top, 0));
    }

    @include mq($w-min-xl, min) {
        padding: 0 40px;
    }

    &--sticky {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100;
    }

    &__placeholder {
        height: 88px;

        @include mq($w-max-phone, max) {
            height: calc(64px + var(--safe-area-inset-top, 0));
        }
    }

    .header {
        margin-top: 0;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        height: 100%;

        .logo {
            height: auto;
            width: 112px;

            @include mq($w-max-phone, max) {
                width: auto;
                height: 35px;
                margin-right: 20px;
            }

            @include mq($w-min-tablet, min) {
                margin-right: 42px;
            }
        }

        &__nav {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 100%;
            column-gap: 1.5rem;

            .nav__link {
                box-sizing: border-box;
                height: 56px;
                margin: 0 1rem 0 0;
                padding: 0 1rem;
                color: #fff;
                font-weight: bold;
                font-size: 1.25rem;
                line-height: 1;
                opacity: 1;

                &--join {
                    box-sizing: border-box;
                    text-align: center;
                    margin-right: 20px;
                    padding: 0 1.5rem;
                    background-color: #f08a4f;
                    font-size: 1.5rem;
                    border: 0;
                    border-radius: 10px;
                    box-shadow: 0 4px 10px rgba(87, 37, 152, 0.2);
                    opacity: 1;
                    transition: all 0.2s;

                    &:hover {
                        background-color: color.scale(
                            $color: #f08a4f,
                            $lightness: -10%
                        );
                    }

                    @include mq($w-max-tablet, max) {
                        align-self: center;
                        margin-right: 0;
                    }

                    @include mq($w-max-phone, max) {
                        height: 40px;
                        font-size: 16px;
                        border-radius: 4px;
                    }
                }
            }

            #menu-toggle {
                @include mq($w-max-phone, max) {
                    margin: 5px 0 0 0;
                    padding: 0 1.25rem 0 0;
                    min-height: auto;
                }
            }
        }

        .math-button--secondary {
            background: transparent;
            border: 2px solid #ffffff;
            border-radius: 8px;
            font-weight: bold;
            font-size: 18px;
            line-height: 1;
            margin-right: 0;
            padding: 0 2rem;
            transition: all 0.2s;

            &:hover,
            &:focus {
                color: #572598;
                background-color: #fff;
            }
        }

        &__dropdown {
            top: 100%;
        }

        .c-dropdown-btn {
            .c-header__link:hover::after {
                opacity: 0;
            }

            > button {
                opacity: 1;
            }
        }
    }
}
</style>
